import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import * as PlotUtil from "@/utils/PlotUtil"
import {List} from "immutable";

export default {
  async searchPlots({ commit }, request) {
    let response = await AiseaApiFactory.get("plot").searchByGeoJson(
      request.plotChildCategoryIds,
      request.northEastLatitude,
      request.northEastLongitude,
      request.southWestLatitude,
      request.southWestLongitude
    );

    const features = [];
    for (let key in response.data) {
      let plot = JSON.parse(response.data[key]);
      features.push(PlotUtil.createFeatures(plot));
    }
    if(features.length > 1) {
      features.push(features[0]);
    }

    commit("SET_FEATURES", features.flat())

    return response.data;
  },
  async getPlot(_, plotId) {
    let res = await AiseaApiFactory.get("plot").get(plotId);

    res.data.plot_points.sort(function (a,b) {
      if(a.sort_order<b.sort_order) return -1;
      if(a.sort_order > b.sort_order) return 1;
      return 0;
    });

    return res.data;
  },
  async createPlot(_, request) {
    let res = await AiseaApiFactory.get("plot").add(request);

    return res.data;
  },
  async updatePlot(_, request) {
    let res = await AiseaApiFactory.get("plot").update(request);

    return res.data;
  },
  async removePlot(_, plotId) {
    let res = await AiseaApiFactory.get("plot").delete(plotId);

    return res.data;
  },
  async resetPlotListState({ commit }) {
    let defaultState = {
      features: List(),
    };
    commit("RESET_STATE", defaultState);
  }
};
